import { Link } from 'react-router-dom';
import MangaCard from '@/components/feature/MangaCard';
import { mangaList, featuredMangaIds } from '@/mocks/manga';

export default function FeaturedManga() {
  const featured = featuredMangaIds.map((id) => mangaList.find((m) => m.id === id)!);

  return (
    <section className="py-10 md:py-14 px-4 md:px-6" data-product-shop="">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="font-heading text-xl md:text-2xl text-foreground-900">
              精选推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-1">编辑精选，不容错过的优质漫画</p>
          </div>
          <Link
            to="/category/qihuan"
            className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1 whitespace-nowrap"
          >
            查看更多 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {featured.map((manga) => (
            <MangaCard key={manga.id} manga={manga} />
          ))}
        </div>
      </div>
    </section>
  );
}